// import React, {Component} from 'react';
import axios from "axios"
import ApiStore from './ApiStore';
// var querystring = require('querystring');


export class PdfStore extends ApiStore{
  constructor() {
    super();
  }

  loadQuotationDoc(qoNo,completeFunc,errorFunc){
    axios.get('/pdf/quotation_doc?qo='+qoNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadQuotationFileDoc(fileId,mode,sheetId,completeFunc,errorFunc){
    axios.get('/pdf/quotationfile_doc?file_id='+fileId+'&sheet_id='+sheetId+'&file_layout='+mode+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadParkingcarDoc(workNo,completeFunc,errorFunc){
    axios.get('/pdf/parkingcar_doc?wo='+workNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadAnyParkingcarDoc(workNo,dn,completeFunc,errorFunc){
    axios.get('/pdf/parkingcar_doc?wo='+workNo+'&dn='+dn+'&format=json&fixinglist=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadCarSummaryDoc(workNo,completeFunc,errorFunc){
    axios.get('/pdf/car_summary_doc?wo='+workNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadWorkCoverFileDoc(workNo,completeFunc,errorFunc){
    axios.get('/pdf/workcoverfile_doc?wo='+workNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadWorkBigJobDoc(workNo,completeFunc,errorFunc){
    axios.get('/pdf/workbigjob_doc?wo='+workNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadFixingListOnCarDoc(workNo,dn,completeFunc,errorFunc){
    axios.get('/pdf/fixinglistoncar_doc?wo='+workNo+'&dn='+dn+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadWorkJobTimeTableDoc(workNo,completeFunc,errorFunc){
    axios.get('/pdf/workjobtimetable_doc?wo='+workNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadSalarySlipDoc(periodic,em_type,completeFunc,errorFunc){
    axios.get('/pdf/allslip_doc?periodic='+periodic+'&em_type='+em_type+'&format=json&time=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadSalarySlipDocByEm(ss,completeFunc,errorFunc){
    axios.get('/pdf/salaryslip_doc?ss='+ss+'&format=json&time=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadStockRecordDoc(recordid,completeFunc,errorFunc){
    axios.get('/pdf/stockrecord_doc?sr='+recordid+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadKKCContractorQuotationDoc(wo,employee_id,completeFunc,errorFunc){
    axios.get('/pdf/fixing_order_doc?wo='+wo+'&employee_id='+employee_id)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadPOReceivedDoc(poNo,completeFunc){
    axios.get('/pdf/purchase_received_doc?po='+poNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPOExportWorkDoc(poNo,completeFunc){
    axios.get('/pdf/purchase_exportwork_doc?po='+poNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPOReturnDoc(poNo,completeFunc){
    axios.get('/pdf/purchase_return_doc?po='+poNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPOImportStockDoc(poNo,completeFunc){
    axios.get('/pdf/purchase_importstock_doc?po='+poNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadTwoPageDoc(type,param,iv,completeFunc){
    axios.get('/pdf/'+type+'?'+param+'='+iv+'&file='+type+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadBNPDoc(type,param,docNo,completeFunc){
    axios.get('/pdf/'+type+'?'+param+'='+docNo+'&file='+type+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadBillingNoteDoc(sn,ivlist,completeFunc){
    axios.get('/pdf/billingnote_doc?'+sn+'='+ivlist)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadTaxInvoiceCoverNoteDoc(tivlist,completeFunc){
    axios.get('/pdf/taxinvoicecovernote_doc?tivlist='+tivlist)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadInvoiceDoc(iv,completeFunc){
    axios.get('/pdf/invoice_doc?iv='+iv+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPhotoBook(completeFunc) {
    axios.get('/pdf/photobook?format=json&cat=hino')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPhotoBookContent(page,completeFunc) {
    axios.get('/pdf/photobook_content?format=json&cat=hino&p='+page)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadWorkJobOfficeTimeTableDoc(workNo,completeFunc,errorFunc){
    axios.get('/pdf/workofficejobtimetable_doc?wo='+workNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadDelivercarDoc(workNo,dn,completeFunc,errorFunc){
    axios.get('/pdf/delivercar_doc?wo='+workNo+'&format=json&dn='+dn)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadCustomApi(url,completeFunc,errorFunc){
    axios.get(url)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadCheckingCarDoc(workNo,dn,completeFunc,errorFunc){
    axios.get('/pdf/checkingcar_doc?format=json&wo='+workNo+'&dn='+dn)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined){
        errorFunc
      }
    })
  }

  loadShippingLabel(type,idlist,completeFunc){
    axios.get('/pdf/shipping_label/'+type+'?idlist='+idlist)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPaymentNoteDoc(pnNo,completeFunc,errorFunc){
    axios.get('/pdf/paymentnote_doc?pn='+pnNo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadGeneralSlipDoc(docNo,docName,completeFunc,errorFunc){
    axios.get('/pdf/generalslip_doc?doc_no='+docNo+'&format=json&doc_name='+docName)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadPrintConfigOptions(docName,completeFunc,errorFunc){
    axios.get('/pdf/print_config_options?doc_name='+docName)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadReceptionDoc(rc,completeFunc){
    axios.get('/pdf/reception_doc?rc='+rc)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadAppointmentQueueDoc(wo,completeFunc){
    axios.get('/pdf/appointmentqueue_doc?wo='+wo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadBorrowingBackupCarDoc(wo,completeFunc){
    axios.get('/pdf/borrowingbackupcar_doc?wo='+wo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPartdisposeByReturnDoc(wo,completeFunc){
    axios.get('/pdf/partdispose_by_return_doc?wo='+wo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadWarrantyworkDoc(wo,completeFunc){
    axios.get('/pdf/warrantywork_doc?wo='+wo+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }
}



export default new PdfStore();





// WEBPACK FOOTER //
// ./src/stores/PdfStore.js